import TldlDurationSelector from './TldlDurationSelector';

export default TldlDurationSelector;
export { DEFAULT_DURATION_MILLIS } from './constants';
